import TendencyIndicator, {
  getTendencyFromPercentageChange,
} from '@/shared/components/tendency-indicator';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/shared/components/ui/avatar';
import { ValueSign } from '@/shared/components/value-sign';
import { getInitials } from '@/shared/utils/avatar-util';
import { formatPercentage } from '@/shared/utils/format';

export const DashboardKpiEntry = ({
  kpiName,
  kpiUnit,
  changePercentage,
  showTendencyIndicator,
  logoUrl,
  orgName,
}: {
  kpiName: string;
  kpiUnit: string;
  changePercentage: number;
  showTendencyIndicator: boolean;
  logoUrl?: string | undefined;
  orgName?: string | undefined;
}) => {
  return (
    <>
      <div className="flex min-w-0 flex-1 flex-row items-center gap-3">
        <Avatar variant={'outlined'}>
          {logoUrl && <AvatarImage src={logoUrl} />}
          <AvatarFallback>
            <span>{getInitials(orgName || kpiName)}</span>
          </AvatarFallback>
        </Avatar>
        <div className="flex min-w-0 flex-col gap-0.5">
          <span className="truncate text-3xs">{kpiName}</span>
          <span className="text-3xs text-custom-grey">{kpiUnit}</span>
        </div>
      </div>
      <div className="flex shrink-0 flex-row items-center gap-3">
        <span className="text-xl font-semibold">
          <ValueSign value={changePercentage} showPositiveSign={false} />
          {formatPercentage(changePercentage)}%
        </span>
        {showTendencyIndicator && (
          <TendencyIndicator
            tendency={getTendencyFromPercentageChange(changePercentage)}
            size="small"
          />
        )}
      </div>
    </>
  );
};
